// Desconto estimado do cupom escolhido, para o resumo da sacola no computador
// (24/10/2026). É estimativa: o valor de verdade sai da validação no pagamento
// (`/coupons/validate`), que olha cliente, entrega e regras do cupom. Mesma
// conta do "economia de R$ X" da janela de cupons.
export function descontoDoCupom(cupom, baseCupom) {
  if (!cupom) return null;
  const minimo = Number(cupom.min_order_value || 0);
  if (minimo > 0 && baseCupom < minimo) return null;
  const rotulo = cupom._premio ? "Prêmio do cartão" : `Cupom ${cupom.code}`;
  if (cupom.discount_type === "free_delivery") return { rotulo, valor: 0, freteGratis: true };
  const v = Number(cupom.discount_value || 0);
  let valor = v;
  if (cupom.discount_type === "percentage") {
    const bruto = baseCupom * (v / 100);
    const teto = Number(cupom.max_discount_value || 0);
    valor = teto > 0 ? Math.min(bruto, teto) : bruto;
  }
  return { rotulo, valor: Math.min(Math.max(0, valor), baseCupom), freteGratis: false };
}
